<template>
  <div class="content-item flex">
    <div class="disease-tab-list flex">
      <span class="disease-tab disease-tab-add" @click="openDeseaseDialog"
        >添加主视频</span
      >
      <span
        class="disease-tab"
        v-if="diseaseLabels && diseaseLabels[0] && diseaseLabels[0].title"
        :key="index"
      >
        {{ diseaseLabels[0].title }}
        <img src="~_img/off.png" alt="del" @click="delDisease(index)" />
      </span>
    </div>
    <!-- <p>给文章打上相关的疾病，可以帮您更好的展示文章</p> -->
    <modal
      :isShow.sync="dialogDeseaseVisible"
      :title="dialogTitles"
      :btnText="btnText"
      :isShowBtn="isShowBtn"
      :width="dialogWidth"
      @clickHandler="clickHandler"
    >
      <div class="search-dialog-wrap">
        <el-input
          placeholder="输入视频ID"
          v-model="searchDiseaseId"
          class="input-with-select"
          maxlength="20"
          show-word-limit
          clearable
        >
          <el-button
            slot="append"
            icon="el-icon-search"
            @click="queryDiseases"
            class="search-but"
            >搜索</el-button
          >
        </el-input>
        <div class="search-disease-body">
          <div class="search-data">
            <el-table :data="searchDiseaseList" style="width: 100%">
              <el-table-column label="视频ID" width="140">
                <template slot-scope="scope">
                  <div class="text-ellipsis" :title="scope.row.videoId">
                    {{ scope.row.videoId }}
                  </div>
                </template>
              </el-table-column>
              <!-- <el-table-column prop="videoId" label="视频ID" width="180"></el-table-column> -->
              <el-table-column prop="title" label="视频标题" width="340">
                <template slot-scope="scope">
                  <div class="text-ellipsis" :title="scope.row.title">
                    {{ scope.row.title }}
                  </div>
                </template>
              </el-table-column>
              <el-table-column
                prop="author"
                label="作者"
                width="100"
              ></el-table-column>
              <el-table-column
                prop="reviewTime"
                label="审核时间"
                width="180"
              ></el-table-column>
            </el-table>
          </div>
          <div
            class="noData flex flex-direction-column justify-content-center align-items-center"
            v-if="isShowSearchNoData"
          >
            <img src="~_img/search-noData.png" alt="没有数据" />
            <p class="errorInfo">没有找到相关数据</p>
          </div>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
import modal from "../modal";
import { queryDrugWarehouse } from "../../api/drugs";
import { request } from "../../utils/axios";

export default {
  name: "GenericNameLabel",
  props: ["data", "isShowEncyclopedia", "functionIds", "isQuestion"],
  data() {
    return {
      deseaseTips: false,
      dialogDeseaseVisible: false, //添加疾病弹窗
      isShowSearchNoData: true,
      searchDiseaseId: "",
      searchDiseaseList: [
        // 示例数据
        // { videoId: 'VID123', title: '这是一个很长的视频标题示例', author: '作者A', reviewTime: '2024-07-15' },
        // { videoId: 'VID124', title: '视频标题2', author: '作者B', reviewTime: '2024-07-14' },
        // 更多数据...
      ],
      searchDiseaseListHistory: [],
      searchDiseaseChecked: [],
      diseaseLabels: [],
      dialogTitles: "添加主视频",
      btnText: ["取消", "确认"],
      dialogWidth: "800px",
      isShowBtn: [true, true],
    };
  },
  components: {
    modal,
  },
  watch: {
    data(val) {
      console.log(val, 9999000);
      this.searchDiseaseChecked = [];
      if (val) {
        for (let i = 0; i < val.length; i++) {
          this.searchDiseaseChecked.push(val[i].diseaseId);
        }
        this.diseaseLabels = val;
      }
      console.log(">>>>>>>><<<<<<", val);
    },
  },
  created() {
    if (this.data && this.data[0] && this.data[0].title) {
      this.diseaseLabels = this.data;
    } else {
      this.diseaseLabels = [];
    }
  },
  methods: {
    clickHandler(val) {
      if (val == "one") {
        this.dialogDeseaseVisible = false;
      }
      if (val == "two") {
        this.addDesease();
        this.$emit("changeVideo", this.diseaseLabels);
        sessionStorage.setItem(
          "changeVideo",
          JSON.stringify(this.diseaseLabels[0])
        );
      }
    },
    //打开添加主视频弹窗
    openDeseaseDialog() {
      if (
        !this.diseaseLabels ||
        this.diseaseLabels.length == 0 ||
        this.diseaseLabels[0].title == "" ||
        !this.diseaseLabels[0].title
      ) {
        this.dialogDeseaseVisible = true;
        this.isShowSearchNoData = false;
        this.searchDiseaseList = [
          // // 示例数据
          // { videoId: 'VID123', title: '这是一个很长的视频标题示例', author: '作者A', reviewTime: '2024-07-15' },
          // { videoId: 'VID124', title: '视频标题2', author: '作者B', reviewTime: '2024-07-14' },
          // // 更多数据...
        ];
        this.searchDiseaseId = "";
      } else {
        console.log(">>><<<", this.diseaseLabels);
        this.$message.error("已有主视频");
      }
    },
    // 获取选中的药品标签
    searchDiseaseChange() {
      // 无关联药品数量约束
      // if (this.searchDiseaseChecked && this.searchDiseaseChecked.length > 1) {
      //   this.$message.error('关联药品最多选1个~')
      //   this.searchDiseaseChecked.pop();
      // }
    },
    getSearchDiseaseListData() {
      return this.searchDiseaseList;
    },
    //添加药品
    addDesease() {
      // 无需对添加数量进行约束
      // if (this.searchDiseaseChecked.length > 1) {
      //   return
      // }
      let dataList = this.getSearchDiseaseListData();
      this.diseaseLabels = this.diseaseLabels || [];
      this.diseaseLabels = dataList;
      this.dialogDeseaseVisible = false;
    },
    delDisease(index) {
      this.diseaseLabels = [];
      this.searchDiseaseChecked = [];
      sessionStorage.setItem(
        "changeVideo",
        JSON.stringify({
          videoId: "",
          title: "",
          author: "",
          playUrl: "",
        })
      );
    },
    // 搜索药品
    queryDiseases() {
      if (this.data) {
        this.searchDiseaseChecked = [];
        this.data.map((item) => {
          this.searchDiseaseChecked.push(item.genericName);
        });
      }
      // if (this.searchDiseaseId) {
      //通过关键词获取药品
      request(this.functionIds.queryEncyclopedia, {
        tenantId: this.$commonJs.getTenantId(),
        contentId: this.searchDiseaseId,
      })
        .then((res) => {
          if (res && res.contentVideos && res.contentVideos[0].playUrl) {
            this.searchDiseaseList = [
              {
                videoId: this.searchDiseaseId,
                title: res.contentVideos[0].videoName,
                author: res.showAuthor.authorName,
                playUrl: res.contentVideos[0].playUrl,
                reviewTime: res.submitDateStr,
              },
            ];
            this.isShowSearchNoData = false;
            this.searchDiseaseListHistory.push(this.searchDiseaseList[0]);
          } else {
            this.searchDiseaseList = [];
            this.isShowSearchNoData = false;
          }
        })
        .catch((err) => {
          this.searchDiseaseList = [];
          this.isShowSearchNoData = false;
        });
      // } else {
      //   this.searchDiseaseList=[];
      //   this.isShowSearchNoData = false
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
$color: #266cee;
.content-item {
  padding-left: 72px;
}

.content-item-label {
  width: 107px;
  text-align: right;
  margin-right: 10px;
  flex-shrink: 0;

  span {
    color: #f62458;
    margin-right: 5px;
  }
}

.input-with-select {
  width: 100% !important;
  padding-bottom: 4px !important;
}

//疾病搜索
.search-dialog-wrap {
  min-height: 138px;
  margin: 20px;

  .search-data {
    max-height: 138px;
    overflow: hidden;
    overflow-y: auto;
    margin-top: 20px;

    &::-webkit-scrollbar {
      width: 4px;
    }

    &::-webkit-scrollbar-thumb {
      width: 4px;
      height: 30px;
      background-color: #989ca5;
    }

    .el-checkbox {
      margin-right: 24px;
    }

    .el-checkbox__label {
      color: #262626;
      padding-left: 6px;
    }

    .el-checkbox__input.is-checked .el-checkbox__inner,
    .el-checkbox__input.is-indeterminate .el-checkbox__inner {
      background: $color;
      border-color: $color;
    }

    .el-checkbox__input.is-checked + .el-checkbox__label {
      color: #262626;
    }

    .el-checkbox__inner:hover {
      border-color: $color;
    }
  }

  .noData {
    img {
      width: 121px;
      height: 78px;
      border: none;
    }

    p {
      font-size: 12px;
      color: #9a9a9a;
      margin-top: 20px;
    }
  }
}

.have {
  cursor: pointer;
}

.btns {
  padding-bottom: 22px;
  padding-top: 40px;
  line-height: 0px !important;
}

.dialog-but {
  padding-top: 9px;
}

:deep(.button) {
  line-height: 0px !important;
}

:deep(.el-button .el-button--primary) {
  padding-top: 10px;
}

.search-but {
  padding-top: 8px;
}

.errorInfo {
  width: 145px !important;
  text-align: right;
  margin-right: 10px;
}

.desease-tips {
  width: 147px !important;
  height: 20px;
  position: absolute;
  left: 878px;
  top: 0;
}

.disease-tab-add {
  width: 150px !important;
}

.disease-tab-list {
  color: #606266;
  display: flex;
  flex-wrap: wrap;
  .disease-tab {
    display: inline-block;
    height: 32px;
    line-height: 32px;
    text-align: center;
    // background: rgba(255, 110, 0, 0.12);
    border: 1px solid #0058ee;
    border-radius: 2px;
    padding: 0 16px;
    margin-right: 28px;
    margin-top: 10px !important;
    cursor: pointer;
    // color: #FF6E00;
    color: #0058ee;
    // margin-bottom: 20px;

    img {
      position: relative;
      top: 0px;
      right: -8px;
      width: 15px;
      height: 15px;
      background-size: 15px;
    }
  }

  .disease-tab-add {
    border: 1px dashed rgba(154, 154, 154, 1);
    background: rgba(255, 255, 255, 1);
    color: rgba(38, 38, 38, 1);

    &::before {
      content: "";
      display: inline-block;
      width: 12px;
      height: 12px;
      background: url("~_img/add.png") no-repeat;
      background-size: 12px;
    }

    &::after {
      display: none;
    }
  }
}
</style>
